// extracted by mini-css-extract-plugin
module.exports = {"component":"DefaultPicker_component__BdQYY","border":"DefaultPicker_border__3_BdP"};